import React from 'react';
import { Column, Text } from '@ydistri/ds';
import type { AsoValidationIssue } from './asoValidationTypes';

interface AsoValidationIssueMessagesProps {
  issues: readonly AsoValidationIssue[];
}

const getIssueKey = (issue: AsoValidationIssue, index: number): string =>
  `${issue.key}-${issue.field ?? 'field'}-${issue.storeTier ?? 'tier'}-${issue.scopeId ?? 'scope'}-${issue.sourceId ?? 'source'}-${issue.targetId ?? 'target'}-${index}`;

export const AsoValidationIssueMessages: React.FC<AsoValidationIssueMessagesProps> = ({
  issues,
}) => {
  if (issues.length === 0) return null;

  return (
    <Column $gap="0.25rem">
      {issues.map((issue, index) => (
        <Text
          key={getIssueKey(issue, index)}
          $size="xSmall"
          $type={issue.severity === 'error' ? 'danger' : 'warning'}
        >
          {issue.message}
        </Text>
      ))}
    </Column>
  );
};
